{
    "Profile_Policy_Vitals.partyStats": "Party Stats",
    "Profile_Policy_Vitals.partyDetails": "Party Details",
    "Profile_Policy_Vitals.partyBrokerage": "Brokerage",
    "Profile_Policy_Vitals.partyAssignedTo": "Assigned To",

    "Profile_Policy_Vitals.vitalStats": "Vital Stats",
    "Profile_Policy_Vitals.policyDetails": "Policy Details",
    "Profile_Policy_Vitals.description": "Description",
    "Profile_Policy_Vitals.submissionReference": "Submission Reference",
    "Profile_Policy_Vitals.policyNumber": "Policy Number",
    "Profile_Policy_Vitals.previousPolicyNumber": "Previous Policy Number",
    "Profile_Policy_Vitals.product": "Product",
    "Profile_Policy_Vitals.lineOfBusiness": "Line of Business",
    "Profile_Policy_Vitals.type": "Type",
    "Profile_Policy_Vitals.status": "Status",
    "Profile_Policy_Vitals.lostReason": "Lost Reason",
    "Profile_Policy_Vitals.effectiveDate": "Effective Date",
    "Profile_Policy_Vitals.expiryDate": "Expiry Date",
    "Profile_Policy_Vitals.quoteExpiryDate": "Quote Expiry Date",
    "Profile_Policy_Vitals.bindable": "Bindable",
    "Profile_Policy_Vitals.billingMethod": "Billing Method",

    "Profile_Policy_Vitals.Status.None": "None",
    "Profile_Policy_Vitals.Status.Incomplete": "Incomplete",
    "Profile_Policy_Vitals.Status.Submitted": "Submitted",
    "Profile_Policy_Vitals.Status.Abandoned": "Abandoned",
    "Profile_Policy_Vitals.Status.Accepted": "Accepted",
    "Profile_Policy_Vitals.Status.Quoted": "Quoted",
    "Profile_Policy_Vitals.Status.UnderwritingRequired": "Underwriting Required",
    "Profile_Policy_Vitals.Status.Referred": "Referred",
    "Profile_Policy_Vitals.Status.QuoteIssued": "Quote Issued",
    "Profile_Policy_Vitals.Status.BindRequested": "Bind Requested",
    "Profile_Policy_Vitals.Status.Bound": "Bound",
    "Profile_Policy_Vitals.Status.Issued": "Issued",
    "Profile_Policy_Vitals.Status.Lost": "Lost",
    "Profile_Policy_Vitals.Status.Cancelled": "Cancelled",
    "Profile_Policy_Vitals.Status.QuoteAccepted": "Quote Accepted",
    "Profile_Policy_Vitals.Status.Quoting": "Quoting",

    "Profile_Policy_Vitals.Type.New": "New Business",
    "Profile_Policy_Vitals.Type.Renewal": "Renewal",
    "Profile_Policy_Vitals.Type.Endorsement": "Endorsement",
    "Profile_Policy_Vitals.Type.Cancellation": "Cancellation",
    "Profile_Policy_Vitals.Type.Reinstatement": "Reinstatement",
    "Profile_Policy_Vitals.Type.Audit": "Audit",
    "Profile_Policy_Vitals.Type.TakeUp": "Take Up",
    "Profile_Policy_Vitals.Type.Certificate": "Certificate"
}
